
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zpracovani-osobnich-udaju",
      function () {
        return require("private-next-pages/zpracovani-osobnich-udaju.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zpracovani-osobnich-udaju"])
      });
    }
  